<script>
  export let id;
</script>

<span {id}></span>

<style>
  span {
    display: block;
    position: relative;
    top: -46px;
    visibility: hidden;
  }
</style>
